import { usePostMessageEventChannel } from 'client/composables/post-message-event-channel'

import type { EmbedEvent, EmbedInboundEventPayloadMap, EmbedOutboundEventPayloadMap } from '../types'

export const makeEmbedEvents = (channel: string) => {
  const eventChannel = usePostMessageEventChannel<EmbedEvent>(channel)

  const emit = <K extends keyof EmbedOutboundEventPayloadMap>(type: K, value?: EmbedOutboundEventPayloadMap[K]) => {
    eventChannel.sendEvent(type as EmbedEvent, value)
  }

  const on = <K extends keyof EmbedInboundEventPayloadMap>(type: K, handler: (value: EmbedInboundEventPayloadMap[K]) => void) => {
    return eventChannel.addListener(type as EmbedEvent, value => handler(value as EmbedInboundEventPayloadMap[K]))
  }

  const sendReadyMessage = () => eventChannel.sendReadyMessage()

  const destroy = () => eventChannel.destroy()

  return {
    emit,
    on,
    sendReadyMessage,
    destroy,
  }
}

const cachedEmbedEvents = new Map<string, ReturnType<typeof makeEmbedEvents>>()

export const useEmbedEvents = (channel = 'xmind-integration-embed-editor') => {
  if (!cachedEmbedEvents.has(channel)) {
    cachedEmbedEvents.set(channel, makeEmbedEvents(channel))
  }
  return cachedEmbedEvents.get(channel)
}
